module.exports = __webpack_public_path__ + "img/qichezhijia.00c9d8dd.png";